import React from 'react';
import Modal from '../../../components/orizon-ui/Modal';
import DataTable from '../../../components/orizon-ui/DataTable';
import SearchInput from '../../../components/orizon-ui/SearchInput';
import Icon from '../../../components/AppIcon';
import { useListaGru } from '../../../components/gru/useListaGru';
import { formattaQta } from '../../../components/gru/scorta';

const COLONNE = [
  { key: 'ean', label: 'Codice', width: 150, render: (r) => <span className="font-mono text-[12px] font-bold text-muted-foreground">{r.ean}</span> },
  { key: 'nome', label: 'Articolo', width: 260, render: (r) => <span className="text-[13px] font-black uppercase tracking-tight text-foreground/80">{r.nome}</span> },
  { key: 'qta', label: 'Giacenza', width: 110, align: 'center', render: (r) => <span className="text-[14px] font-black tabular-nums text-foreground/80">{formattaQta(r.qta, 3)}</span> },
  { key: 'qta_da_movimenti', label: 'Da movimenti', width: 130, align: 'center', render: (r) => <span className="text-[14px] font-black tabular-nums text-foreground/80">{formattaQta(r.qta_da_movimenti, 3)}</span> },
  {
    key: 'differenza', label: 'Differenza', width: 120, align: 'center',
    render: (r) => <span className="text-[14px] font-black tabular-nums text-red-500">{Number(r.differenza) > 0 ? '+' : ''}{formattaQta(r.differenza, 3)}</span>,
  },
  { key: 'n_movimenti', label: 'Movimenti', width: 110, align: 'center', render: (r) => <span className="text-[12px] font-bold tabular-nums text-muted-foreground">{r.n_movimenti ?? 0}</span> },
];

/**
 * Controllo di coerenza: confronta la giacenza salvata con la somma dei movimenti (gru_v_audit_qta).
 * Elenco vuoto = tutto coerente.
 */
const AuditQta = ({ onClose }) => {
  const lista = useListaGru({
    entita: 'audit',
    filtri: {},
    ordineIniziale: { key: 'nome', direction: 'asc' },
    perPagina: 25,
  });

  const coerente = !lista.loading && lista.totale === 0 && lista.ricercaInput === '';

  return (
    <Modal isOpen onClose={onClose} titolo="Controllo giacenze" etichetta="Magazzino GRU · Audit" larghezza="xl">
      <p className="text-[11px] font-bold text-muted-foreground/70 leading-relaxed">
        Confronta la giacenza di ogni articolo con la somma dei suoi movimenti nello storico. Ogni riga è una differenza da verificare.
      </p>

      {coerente ? (
        <div className="flex flex-col items-center justify-center gap-3 py-16 border-2 border-dashed border-emerald-500/30 rounded-3xl bg-emerald-500/5">
          <Icon name="ShieldCheck" size={40} className="text-emerald-500" />
          <span className="text-sm font-black uppercase tracking-widest text-emerald-500">Tutte le giacenze sono coerenti</span>
        </div>
      ) : (
        <>
          <SearchInput value={lista.ricercaInput} onChange={lista.setRicercaInput} placeholder="Cerca per codice o nome..." />
          <DataTable
            colonne={COLONNE}
            righe={lista.righe}
            totale={lista.totale}
            loading={lista.loading}
            pagina={lista.pagina}
            perPagina={lista.perPagina}
            onPagina={lista.setPagina}
            sort={lista.sort}
            onSort={lista.onSort}
            rigaKey="articolo_id"
            messaggioVuoto="Nessuna discrepanza trovata"
            altezzaMax="max-h-[45dvh]"
          />
        </>
      )}
    </Modal>
  );
};

export default AuditQta;
